import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const DownloadVendor = ({
  open,
  onClose,
  handleConfirm,
  modalTextType,
  oneKeyId,
  vendorResponse,
  recordType,
}) => {
  const modalTextConfirm = `You are about to download this profile to Lilly systems. In 3 days the ${recordType} will be available in downstream systems with an Enterprise ID and will be able to be used for business purposes. Would you like to proceed?`;
  const modalTextSuccess = `The selected profile with OneKey ID: ${oneKeyId} has been successfully subscribed. The ${recordType} will be available in downstream systems with an Enterprise ID in 3 days. Shell Profile Could not be created due to: No Speciality found in workplace`;
  const modalTextError =
    "There was an error downloading the vendor profile. Please try again later.";

  const profileAlreadyExist = `The selected profile with OneKey ID: ${oneKeyId} Reference ID: ${vendorResponse?.ReferenceId} already exists in Enterprise Profile Hub (EPH) with HCPReference. The Enterprise Customer Search (ECS) team has been notified about the missing profile from ECS.`;

  const handleConfirmModal = () => {
    handleConfirm();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="customized-dialog-title"
    >
      <DialogTitle sx={{ textAlign: "left", color: "error.main" }}>
        <Typography variant="h5" style={{ color: "#000" }} component="div">
          {modalTextType === "confirmation"
            ? "Note"
            : modalTextType === "success"
              ? "Success"
              : modalTextType === "available"
                ? "Profile already exists in EPH"
                : "Error"}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", pb: 2 }}>
        <Typography
          variant="body1"
          color="text.secondary"
          style={{ textAlign: "justify" }}
          paragraph
        >
          {modalTextType === "confirmation"
            ? modalTextConfirm
            : modalTextType === "success"
              ? modalTextSuccess
              : modalTextType === "available"
                ? profileAlreadyExist
                : modalTextError}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "right", pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          size="large"
          color="error"
          sx={{ minWidth: 120 }}
        >
          {modalTextType === "confirmation" ? "Cancel" : "Close"}
        </Button>
        {modalTextType === "confirmation" && (
          <Button
            onClick={handleConfirmModal}
            variant="contained"
            color="error"
            size="large"
            sx={{ minWidth: 120 }}
          >
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DownloadVendor;
